import { gql } from '@apollo/client';

import { ECondition, EReward, TAchievement } from '../interfaces';

export interface ICreateAchievementRequest {
  input: {
    name: string;
    status: 'ACTIVE';
    conditions: Array<{
      name: ECondition;
      value: number;
    }>;
    rewards: Array<{
      name: EReward;
      value: number;
    }>;
  };
}
export interface ICreateAchievementResponse {
  createAchievement: TAchievement;
}
export const CREATE_ACHIEVEMENT = gql`
  mutation createAchievement($input: AchievementInput!) {
    createAchievement(input: $input) {
      id
      name
      conditions {
        name
        value
      }
      rewards {
        name
        value
      }
    }
  }
`;
